


















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { partSalesService, tenantService } from '@/shared';
import { Tenant } from '@/models/admin/tenant';
import { VHeaders, PaginationModel } from '@/models/pagedlistmodel';
import { Base } from '@/components/common/base';
import { getCashierTicketsHeaders } from '@/models/fixedops/partsales';

@Component({
  components: {
    Grid: () => import('@/components/common/app.grid.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
  },
})
export default class CashierTicketsListPage extends Base {
  public pagedCashier: any[] = [];
  public pagination = new PaginationModel('customerName');

  public flags = {
    loading: false,
  };

  public tenantToDelete: Tenant = {
    id: 0,
    name: '',
    code: '',
    isEnabled: true
  };
  public headers: VHeaders[] = getCashierTicketsHeaders(this);
  public actions: any[] = [];
  public mounted() {
    // activating tab
    this.$root.$emit('sidebar.layout.vue', 'cashierTickets');

    this.getTicktes();
  }

  public async getTicktes(): Promise<void> {
    try {
      this.flags.loading = true;
      const response = await partSalesService.getAllCCTickets();
      if (response.length != undefined) {
        this.pagedCashier = response;
        this.pagination.totalItems =
          this.pagedCashier.length > 0 ? this.pagedCashier.length : 0;
      }
    } finally {
      this.flags.loading = false;
    }
  }
  public pageChanged(paging: any) {
    this.pagination = paging;
  }
}
